/** @jsxImportSource @emotion/react */
"use client";

import type { SVGProps } from "react";

/**
 * The up/down chevron that marks a plan pill as a selector. Rendered as raw
 * markup rather than through IconWrapper so it stays pixel-identical to the
 * inline copies it replaces on the payments and web select screens.
 */
export const SelectorIcon = (props: SVGProps<SVGSVGElement>) => (
  <svg
    fill="none"
    height="14"
    viewBox="0 0 8 14"
    width="8"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M7 9L4 11L1 9"
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth="2"
    />
    <path
      d="M1 5L4 3L7 5"
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth="2"
    />
  </svg>
);
